module.exports = __webpack_public_path__ + "lp/img/manual_icon_sp_off@2x.12cfa20b.png";